import { render, staticRenderFns } from "./CompProfileExtraInformationCard.vue?vue&type=template&id=3e7d2a19&scoped=true"
import script from "./CompProfileExtraInformationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileExtraInformationCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d2a19",
  null
  
)

export default component.exports